// import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
// import { flushSync } from "react-dom";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import toast, { Toaster } from "react-hot-toast";
// import api from "../chat/api";
// import { promptIcons, BotAvatarIcon, ScrollBottomIcon, SendIcon, NewICon } from "./ChatIcons";
// import MemoizedMarkdown from "./Projects/MemoizedMarkdown";
// import PromptLibraryModal from "./PromptLibraryModal";
// import DeleteChatModal from "./DeleteChatModal";
// import Tooltip from "./Projects/Project Page/Tooltip";
// import SourceViewerModal from "./SourceViewerModal";

// const INITIAL_HEIGHT = 40;
// const MAX_HEIGHT = 200;

// const WS_BASE_URL = process.env.REACT_APP_WS_URL || "ws://localhost:8000";

// const groupChatsByDate = (chatSessions) => {
//   if (!chatSessions || chatSessions.length === 0) return [];

//   const groups = {
//     "Today": [],
//     "Yesterday": [],
//     "Last 7 Days": [],
//     "Older": []
//   };

//   const now = new Date();
//   now.setHours(0, 0, 0, 0);

//   chatSessions.forEach(chat => {
//     const chatDate = new Date(chat.last_message_timestamp);
//     const chatDay = new Date(chatDate);
//     chatDay.setHours(0, 0, 0, 0);

//     const diffTime = now - chatDay;
//     const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

//     if (diffDays === 0) {
//       groups["Today"].push(chat);
//     } else if (diffDays === 1) {
//       groups["Yesterday"].push(chat);
//     } else if (diffDays > 1 && diffDays <= 7) {
//       groups["Last 7 Days"].push(chat);
//     } else {
//       groups["Older"].push(chat);
//     }
//   });

//   return Object.entries(groups)
//     .filter(([_, chats]) => chats.length > 0)
//     .map(([group, chats]) => ({ group, chats }));
// };

// const KBChat = ({ isMenuOpen }) => {
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [inputMessage, setInputMessage] = useState("");
//   const navigate = useNavigate();

//   const [displayName, setDisplayName] = useState("");
//   const textareaRef = useRef(null);

//   const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);

//   const [activeSource, setActiveSource] = useState(null);

//   const [hoveredChatId, setHoveredChatId] = useState(null);
//   const [popoverOpenForId, setPopoverOpenForId] = useState(null);
//   const [renamingChatId, setRenamingChatId] = useState(null);
//   const [renameValue, setRenameValue] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const renameInputRef = useRef(null);

//   const [chatToDelete, setChatToDelete] = useState(null);

//   const [chatHistory, setChatHistory] = useState([]);
//   const [isChatHistoryLoading, setIsChatHistoryLoading] = useState(true);
//   const [isLoadingChat, setIsLoadingChat] = useState(false);

//   const chatContainerRef = useRef(null);
//   const messagesEndRef = useRef(null);
//   const lastUserMessageRef = useRef(null);
//   const shouldAutoScrollRef = useRef(false);

//   const [chatId, setChatId] = useState(null);
//   const [isConnected, setIsConnected] = useState(false);
//   const [isStreaming, setIsStreaming] = useState(false);

//   const streamingMessageRef = useRef("");
//   const [streamingMessage, setStreamingMessage] = useState("");

//   const [showScrollToBottom, setShowScrollToBottom] = useState(false);
//   const [lastStreamingHeight, setLastStreamingHeight] = useState(0);
//   const [checkScrollInterval, setCheckScrollInterval] = useState(null);

//   const wsRef = useRef(null);
//   const reconnectTimeoutRef = useRef(null);
//   const messageQueueRef = useRef([]);
//   const pendingMetaRef = useRef(null);

//   const [thumbsUpClicked, setThumbsUpClicked] = useState({});
//   const [thumbsDownClicked, setThumbsDownClicked] = useState({});
//   const [copiedMessageId, setCopiedMessageId] = useState(null);
//   const [messageMetaMap, setMessageMetaMap] = useState({});

//   const hasMessages = messages.length > 0;

//   const suggestedPrompts = [
//     "Summarize the documents in my knowledge base",
//     "What changed in the latest compliance update?",
//     "Find invoices for pricing strategies in 2025",
//     'Show me where "Proposal Evaluation Criteria" appears',
//   ];

//   const fetchChatHistory = async (showLoader = true) => {
//     if (showLoader) setIsChatHistoryLoading(true);
//     try {
//       const response = await api.get(`/api/v1/rfp/kb-copilot/chats/`);
//       if (response.data && response.data.chat_sessions) {
//         const groupedChats = groupChatsByDate(response.data.chat_sessions);
//         setChatHistory(groupedChats);
//       }
//     } catch (error) {
//       console.error("Failed to fetch chat history:", error);
//       if (showLoader) {
//         toast.error("Failed to load chat history.", {
//           position: "bottom-right",
//           duration: 2000,
//           style: {
//             background: "#1a1a1a",
//             color: "#fff",
//             borderRadius: "10px",
//             fontSize: "14px",
//           },
//         });
//       }
//     } finally {
//       if (showLoader) setIsChatHistoryLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (popoverOpenForId && !e.target.closest('.chat-item-container')) {
//         setPopoverOpenForId(null);
//       }
//     };
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, [popoverOpenForId]);

//   useEffect(() => {
//     if (renamingChatId && renameInputRef.current) {
//       renameInputRef.current.focus();
//       renameInputRef.current.setSelectionRange(0, renameInputRef.current.value.length);
//     }
//   }, [renamingChatId]);

//   const handleRenameSubmit = async (e) => {
//     e.preventDefault();
//     if (!renameValue.trim()) {
//       setRenamingChatId(null);
//       return;
//     }

//     try {
//       await api.post(`/api/v1/copilot/rename-session/`, {
//         chat_id: renamingChatId,
//         new_title: renameValue.trim()
//       });
//       setChatHistory(prevGroups => prevGroups.map(group => ({
//         ...group,
//         chats: group.chats.map(chat =>
//           chat.chat_id === renamingChatId
//             ? { ...chat, title: renameValue.trim() }
//             : chat
//         )
//       })));
//       toast.success("Chat renamed successfully", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     } catch (error) {
//       console.error("Failed to rename:", error);
//       toast.error("Failed to rename chat", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     } finally {
//       setRenamingChatId(null);
//     }
//   };

//   const onChatDeleted = (deletedId) => {
//     setChatHistory(prevGroups => {
//       const newGroups = prevGroups.map(group => ({
//         ...group,
//         chats: group.chats.filter(c => c.chat_id !== deletedId)
//       })).filter(g => g.chats.length > 0);
//       return newGroups;
//     });

//     if (chatId === deletedId) {
//       handleStartNewChat();
//     }
//   };

//   const submitFeedback = async (messageId, feedbackType) => {
//     const meta = messageMetaMap[messageId];
//     if (!meta) return;

//     try {
//       await api.post("/api/v1/rfp/feedback/", {
//         message_id: meta.django_message_id,
//         feedback_type: feedbackType,
//         run_id: meta.run_id,
//         user_feedback: feedbackType === "up" ? "Good response" : "Bad response",
//       });
//       toast.success("Thanks for giving your feedback", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     } catch (error) {
//       console.error("Failed to submit feedback:", error);
//       toast.error("Failed to submit feedback", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     }
//   };

//   const checkScrollPosition = () => {
//     if (!chatContainerRef.current) return;
//     const el = chatContainerRef.current;
//     const scrollDiff = el.scrollHeight - el.scrollTop - el.clientHeight;
//     setShowScrollToBottom(scrollDiff > 100);
//     if (scrollDiff > 300) shouldAutoScrollRef.current = false;
//   };

//   const scrollToBottom = () => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTo({
//         top: chatContainerRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//       shouldAutoScrollRef.current = true;
//       setTimeout(() => setShowScrollToBottom(false), 300);
//     }
//   };

//   const scrollToLastUserMessage = () => {
//     if (lastUserMessageRef.current && chatContainerRef.current) {
//       lastUserMessageRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//       shouldAutoScrollRef.current = false;
//     }
//   };

//   useEffect(() => {
//     if (!isStreaming || !shouldAutoScrollRef.current) return;
//     const currentHeight = streamingMessage.length;
//     const heightDiff = currentHeight - lastStreamingHeight;

//     if (heightDiff > 5 && chatContainerRef.current) {
//       const el = chatContainerRef.current;
//       const scrollDiff = el.scrollHeight - el.scrollTop - el.clientHeight;
//       if (scrollDiff < 200) {
//         requestAnimationFrame(() => {
//           el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
//         });
//       }
//     }
//     setLastStreamingHeight(currentHeight);
//   }, [streamingMessage, isStreaming]);

//   useEffect(() => {
//     if (isStreaming) {
//       const interval = setInterval(checkScrollPosition, 500);
//       setCheckScrollInterval(interval);
//       return () => clearInterval(interval);
//     } else if (checkScrollInterval) {
//       clearInterval(checkScrollInterval);
//       setCheckScrollInterval(null);
//     }
//   }, [isStreaming]);

//   useEffect(() => {
//     const full_name = localStorage.getItem("full_name") || localStorage.getItem("fullName") || "";
//     const username = localStorage.getItem("username") || "";
//     setDisplayName(full_name || username);

//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     } else {
//       navigate("/signin");
//     }

//     setChatId(null);
//     setMessages([]);
//     setMessageMetaMap({});
//     fetchChatHistory(true);

//     return () => {
//       if (wsRef.current) wsRef.current.close(1000, "Leaving page");
//     };
//   }, [navigate]);

//   const initiateNewChat = async () => {
//     try {
//       const response = await api.post(`api/v1/copilot/new-chat/`, { chat_module: "rfp_kb_copilot" });
//       if (response.data.chat_id) {
//         setChatId(response.data.chat_id);
//         fetchChatHistory(false);
//         return response.data.chat_id;
//       } else if (response.data.msg === "You already have a recent chat session.") {
//         const activeChats = await api.get(`api/v1/copilot/chats/`);
//         const latestChat = activeChats.data?.chat_sessions?.[0];
//         if (latestChat?.id) {
//           setChatId(latestChat.id);
//           return latestChat.id;
//         }
//       }
//       throw new Error("Chat ID not received");
//     } catch (error) {
//       toast.error("Failed to start a new chat. Please try again.", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//       return null;
//     }
//   };

//   const handleWebSocketMessage = (data) => {
//     const { type, status, message } = data;
//     if (status === "connected") return;

//     if (type === "info") {
//       setIsStreaming(true);
//       streamingMessageRef.current = "";
//       setStreamingMessage("");
//       setTimeout(scrollToLastUserMessage, 100);
//       return;
//     }

//     if (type === "progress") {
//       if (data.source === "true" || data.source === true) {
//         const backendPage = data.page;
        
//         if (!backendPage || String(backendPage).trim() === "" || isNaN(parseInt(backendPage, 10))) {
//           return;
//         }

//         const displayPageNum = parseInt(backendPage, 10);
//         const safeFileName = (data.file_name || "").replace(/"/g, "&quot;");
//         const safeFileUrl = (data.file_url || "").replace(/"/g, "&quot;");
        
//         const rawContent = data.page_content || "";
//         const singleLineContent = rawContent.replace(/[\r\n]+/g, " ");
//         const safePageContent = singleLineContent.replace(/"/g, "&quot;");

//         const inlineSourceHtml = ` <sup style="margin-left:2px;"><a href="#source_viewer" data-filename="${safeFileName}" data-fileurl="${safeFileUrl}" data-page="${displayPageNum}" data-pagecontent="${safePageContent}" style="font-size:12px; font-weight:600; color:#C95EBE; text-decoration:none; cursor:pointer;" title="View Source in ${safeFileName}, Page ${displayPageNum}">${displayPageNum}</a></sup>`;

//         streamingMessageRef.current += inlineSourceHtml;
//         setStreamingMessage(streamingMessageRef.current);
//       } else {
//         streamingMessageRef.current += message;
//         setStreamingMessage(streamingMessageRef.current);
//       }
//       return;
//     }

//     if (type === "final") {
//       pendingMetaRef.current = {
//         run_id: data.data?.run_id || data.run_id || null,
//         django_message_id: data.data?.bot_message_id || data.bot_message_id || null,
//       };
//       return;
//     }

//     if (type === "completed") {
//       const finalText = streamingMessageRef.current;
//       const meta = pendingMetaRef.current;
//       const completedMsgId =
//         meta?.django_message_id || Date.now();
//       const completedRunId =
//         meta?.run_id || null;

//       if (finalText.trim()) {
//         const botMessage = {
//           id: completedMsgId,
//           text: finalText,
//           sender: "bot",
//           timestamp: new Date().toISOString(),
//         };
//         setMessages((prev) => [...prev, botMessage]);

//         if (completedRunId) {
//           setMessageMetaMap((prev) => ({
//             ...prev,
//             [completedMsgId]: {
//               run_id: completedRunId,
//               django_message_id: completedMsgId,
//             },
//           }));
//         }
//       }
//       pendingMetaRef.current = null;
//       streamingMessageRef.current = "";
//       setStreamingMessage("");
//       setIsStreaming(false);
//       setLoading(false);
//       setLastStreamingHeight(0);
//       setTimeout(checkScrollPosition, 100);
//       fetchChatHistory(false);
//       return;
//     }

//     if (type === "error" || data.error) {
//       const errorMessage = {
//         id: Date.now(),
//         text: data.error || message || "An error occurred. Please try again.",
//         sender: "bot",
//         timestamp: new Date().toISOString(),
//         isError: true,
//       };
//       setMessages((prev) => [...prev, errorMessage]);
//       pendingMetaRef.current = null;
//       streamingMessageRef.current = "";
//       setStreamingMessage("");
//       setIsStreaming(false);
//       setLoading(false);
//       return;
//     }
//   };

//   const connectWebSocket = (chatIdToUse) => {
//     if (!chatIdToUse || !token) return;
//     if (wsRef.current) wsRef.current.close();
//     const wsUrl = `${WS_BASE_URL}/ws/rfp-kb-copilot-chat/${chatIdToUse}/?token=${token}`;
//     const ws = new WebSocket(wsUrl);
//     wsRef.current = ws;

//     ws.onopen = () => {
//       setIsConnected(true);
//       while (messageQueueRef.current.length > 0) {
//         ws.send(JSON.stringify(messageQueueRef.current.shift()));
//       }
//     };
//     ws.onmessage = (event) => {
//       try { handleWebSocketMessage(JSON.parse(event.data)); } catch (error) {}
//     };
//     ws.onerror = () => setIsConnected(false);
//     ws.onclose = (event) => {
//       setIsConnected(false);
//       if (event.code !== 1000) {
//         reconnectTimeoutRef.current = setTimeout(() => {
//           if (chatId) connectWebSocket(chatId);
//         }, 3000);
//       }
//     };
//   };

//   const sendWebSocketMessage = (messageText) => {
//     const payload = { client_message: messageText };
//     if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//       wsRef.current.send(JSON.stringify(payload));
//     } else {
//       messageQueueRef.current.push(payload);
//       if (chatId) connectWebSocket(chatId);
//     }
//   };

//   const resizeTextarea = (ta) => {
//     if (!ta) return;
//     ta.style.height = `${INITIAL_HEIGHT}px`;
//     if (ta.value.trim() || ta.value.length > 0) {
//       const full = ta.scrollHeight;
//       const next = full <= INITIAL_HEIGHT ? INITIAL_HEIGHT : Math.min(full, MAX_HEIGHT);
//       ta.style.height = `${next}px`;
//       ta.style.overflowY = full > MAX_HEIGHT ? "auto" : "hidden";
//     } else {
//       ta.style.height = `${INITIAL_HEIGHT}px`;
//       ta.style.overflowY = "hidden";
//     }
//   };

//   const handleTextInputChange = (e) => {
//     setInputMessage(e.target.value);
//     if (e.target.value.trim() || e.target.value.length > 0) {
//       resizeTextarea(e.target);
//     } else {
//       e.target.style.height = `${INITIAL_HEIGHT}px`;
//       e.target.style.overflowY = "hidden";
//     }
//   };

//   useLayoutEffect(() => {
//     if (inputMessage === "" && textareaRef.current) {
//       textareaRef.current.style.height = `${INITIAL_HEIGHT}px`;
//       textareaRef.current.style.overflowY = "hidden";
//     }
//   }, [inputMessage]);

//   const handleSendMessage = async () => {
//     if (!inputMessage.trim() || loading) return;

//     const userMessageText = inputMessage.trim();
//     const userMessage = {
//       id: Date.now(),
//       text: userMessageText,
//       sender: "user",
//       timestamp: new Date().toISOString(),
//     };

//     setMessages((prev) => [...prev, userMessage]);
//     setInputMessage("");

//     if (textareaRef.current) {
//       textareaRef.current.style.height = `${INITIAL_HEIGHT}px`;
//       textareaRef.current.style.overflowY = "hidden";
//     }

//     setLoading(true);
//     shouldAutoScrollRef.current = false;
//     streamingMessageRef.current = "";
//     setStreamingMessage("");

//     try {
//       let currentChatId = chatId;
//       if (!currentChatId) {
//         currentChatId = await initiateNewChat();
//         if (!currentChatId) throw new Error("Failed to create chat session");
//       }

//       if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
//         connectWebSocket(currentChatId);
//         messageQueueRef.current.push({ client_message: userMessageText });
//       } else {
//         sendWebSocketMessage(userMessageText);
//       }
//     } catch (error) {
//       toast.error("Failed to send message. Please try again.", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//       setMessages((prev) => [
//         ...prev,
//         {
//           id: Date.now() + 1,
//           text: "An error occurred. Please try again.",
//           sender: "bot",
//           isError: true,
//         },
//       ]);
//       setLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   const handlePromptClick = (prompt) => {
//     setInputMessage(prompt);
//     if (textareaRef.current) {
//       textareaRef.current.focus();
//       setTimeout(() => resizeTextarea(textareaRef.current), 0);
//     }
//   };

//   const handleStartNewChat = () => {
//     setChatId(null);
//     setMessages([]);
//     setMessageMetaMap({});
//     setInputMessage("");
//     setLoading(false);
//     setIsStreaming(false);
//     setStreamingMessage("");
//     streamingMessageRef.current = "";
//     pendingMetaRef.current = null;
//     if (wsRef.current) {
//       wsRef.current.close(1000, "Starting new chat");
//       wsRef.current = null;
//     }
//   };

//   const handleLoadPastChat = async (pastChatId) => {
//     if (chatId === pastChatId || popoverOpenForId === pastChatId || renamingChatId === pastChatId) return;

//     setChatId(pastChatId);
//     setIsLoadingChat(true);
//     setLoading(false);
//     setIsStreaming(false);
//     setStreamingMessage("");
//     streamingMessageRef.current = "";
//     pendingMetaRef.current = null;
//     setInputMessage("");

//     if (wsRef.current) {
//       wsRef.current.close(1000, "Switching chats");
//       wsRef.current = null;
//     }

//     try {
//       const response = await api.get(`/api/v1/copilot/get-chat-sessions/${pastChatId}/`);
//       let chatData = [];
//       if (response.data && Array.isArray(response.data.chat_history)) {
//         chatData = response.data.chat_history;
//       }

//       const metaMap = {};
//       const formattedMessages = chatData.map((msg) => {
//         const messageId =
//           msg.django_message_id || Date.now() + Math.random();

//         if (!msg.is_client && msg.run_id) {
//           metaMap[messageId] = {
//             run_id: msg.run_id,
//             django_message_id: msg.django_message_id || msg.bot_message_id || null,
//           };
//         }

//         return {
//           id: messageId,
//           text: msg.message || "",
//           sender: msg.is_client ? "user" : "bot",
//           timestamp: msg.timestamp || new Date().toISOString(),
//           isError: false,
//         };
//       });

//       setMessages(formattedMessages);
//       setMessageMetaMap(metaMap);
//       connectWebSocket(pastChatId);
//     } catch (error) {
//       toast.error("Failed to load this chat. Please try again later.", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
          
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//       setMessages([]);
//       setMessageMetaMap({});
//     } finally {
//       setIsLoadingChat(false);
//       setTimeout(scrollToBottom, 100);
//     }
//   };

//   const handleCopy = (messageId, text) => {
//     const textWithoutHtml = text.replace(
//       /<sup\b[^>]*><a\b[^>]*>(.*?)<\/a><\/sup>/gi,
//       " [$1] "
//     );
//     navigator.clipboard.writeText(textWithoutHtml).then(() => {
//       setCopiedMessageId(messageId);
//       setTimeout(() => setCopiedMessageId(null), 2000);
//     });
//   };

//   const handleMarkdownClick = (e) => {
//     const anchor = e.target.closest("a");
//     if (anchor && anchor.getAttribute("href") === "#source_viewer") {
//       e.preventDefault();

//       const fileName = anchor.getAttribute("data-filename");
//       const fileUrl = anchor.getAttribute("data-fileurl");
//       const page = anchor.getAttribute("data-page");
//       const pageContent = anchor.getAttribute("data-pagecontent");

//       if (!fileUrl && !fileName) return;

//       setActiveSource({
//         file_name: fileName,
//         file_url: fileUrl,
//         page: page,
//         page_content: pageContent,
//       });
//     }
//   };

//   const renderMessageText = (text) => <MemoizedMarkdown content={text} />;

//   const filteredChatHistory = chatHistory
//     .map((group) => ({
//       ...group,
//       chats: group.chats.filter((chat) =>
//         chat.title.toLowerCase().includes(searchQuery.toLowerCase())
//       ),
//     }))
//     .filter((group) => group.chats.length > 0);

//   return (
//     <div className="h-screen flex flex-col bg-[#FEF9F7] font-outfit overflow-hidden">
//       <Toaster />

//       <SourceViewerModal
//         source={activeSource}
//         onClose={() => setActiveSource(null)}
//       />

//       {isPromptModalOpen && (
//         <PromptLibraryModal
//           onClose={() => setIsPromptModalOpen(false)}
//           onSelectPrompt={(promptText) => {
//             setIsPromptModalOpen(false);
//             handlePromptClick(promptText);
//           }}
//         />
//       )}

//       <DeleteChatModal
//         isOpen={!!chatToDelete}
//         onClose={() => setChatToDelete(null)}
//         chatId={chatToDelete}
//         onDeleted={onChatDeleted}
//       />

//       <header className="flex-shrink-0 pt-4 px-2 pb-4 bg-white border-b-2 border-[#0000001A] w-full z-20">
//         <button
//           onClick={() => navigate("/rfp-knowledgeBase")}
//           className="inline-flex items-center gap-3 text-black hover:text-gray-700 transition-colors"
//         >
//           <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
//           </svg>
//           <span className="font-semibold text-[18px]">Go to Knowledge Base</span>
//         </button>
//       </header>

//       <div className="flex-1 flex overflow-hidden">
//         <div className="w-[300px] md:w-[320px] bg-white border-r border-gray-200 flex flex-col flex-shrink-0 z-10">
//           <div className="px-5 py-4 flex-shrink-0">
//             <h2 className="text-[13px] text-[#4B5563] font-medium mb-3">YOUR CHATS</h2>
//             <div className="flex gap-3 items-center mb-4">
//               <div className="flex-1 flex items-center bg-[#F3F4F6] rounded-[6px] px-3 py-2">
//                 <svg className="w-[18px] h-[18px] text-[#6B7280] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35m1.85-5.15a7 7 0 11-14 0 7 7 0 0114 0z" />
//                 </svg>
//                 <input
//                   type="text"
//                   placeholder="Search a chat..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="w-full bg-transparent border-none outline-none text-[14px] ml-2 text-[#3F3F46] placeholder-[#9CA3AF] focus:outline-none"
//                   style={{ fontSize: "14px", lineHeight: "20px" }}
//                 />
//               </div>

//               <Tooltip content="Start New Chat" placement="right">
//                 <button
//                   onClick={handleStartNewChat}
//                   className="text-[#6B7280] hover:text-black transition-colors flex-shrink-0"
//                 >
//                   <NewICon />
//                 </button>
//               </Tooltip>
//             </div>
//             <div className="border-b border-gray-100 mt-2"></div>
//           </div>

//           <div className="flex-1 overflow-y-auto px-5 pb-4 custom-scrollbar relative">
//             {isChatHistoryLoading ? (
//               <div className="flex items-center justify-center py-6 text-[13px] text-[#6B7280]">Loading your chats...</div>
//             ) : chatHistory.length === 0 ? (
//               <div className="flex items-center justify-center py-6 text-[13px] text-[#6B7280]">No chat history found.</div>
//             ) : filteredChatHistory.length === 0 ? (
//               <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
//                 <span className="text-[28px] mb-2">🔍</span>
//                 <p className="text-[14px] text-[#4B5563] font-medium">No results found for "{searchQuery}"</p>
//                 <p className="text-[12px] text-[#9CA3AF] mt-1">Try another keyword or start a new chat.</p>
//               </div>
//             ) : (
//               filteredChatHistory.map((group, index) => (
//                 <div key={index} className="mb-3">
//                   <h3 className="text-[#BD4AB1] text-[15px] font-medium mb-2">{group.group}</h3>
//                   <div className="flex flex-col gap-1">
//                     {group.chats.map((chat) => (
//                       <div
//                         key={chat.chat_id}
//                         className="chat-item-container relative"
//                         onMouseEnter={() => setHoveredChatId(chat.chat_id)}
//                         onMouseLeave={() => setHoveredChatId(null)}
//                       >
//                         <div
//                           onClick={() => handleLoadPastChat(chat.chat_id)}
//                           className={`cursor-pointer group px-2 py-1 rounded-md transition-colors flex justify-between items-start ${
//                             chatId === chat.chat_id || popoverOpenForId === chat.chat_id
//                               ? 'bg-[#F3F4F6] -mx-2 px-4'
//                               : '-mx-2 px-4 hover:bg-gray-50'
//                           }`}
//                         >
//                           <div className="flex-1 min-w-0 pr-4">
//                             {renamingChatId === chat.chat_id ? (
//                               <form onSubmit={handleRenameSubmit}>
//                                 <input
//                                   ref={renameInputRef}
//                                   type="text"
//                                   value={renameValue}
//                                   onChange={(e) => setRenameValue(e.target.value)}
//                                   onBlur={handleRenameSubmit}
//                                   className="w-full h-8 text-[14px] leading-snug rounded-[4px] border-2 border-[#E5C1DD] outline-none bg-white text-[#000000B3] placeholder-gray-400 focus:outline-none shadow-sm transition-[border-color,box-shadow]"
//                                   style={{ fontSize: "14px", lineHeight: "20px" }}
//                                 />
//                               </form>
//                             ) : (
//                               <h4 className={`text-[14px] font-medium leading-snug mb-0.5 truncate ${
//                                 chatId === chat.chat_id || popoverOpenForId === chat.chat_id
//                                   ? 'text-[#000000B3]'
//                                   : 'text-[#000000B3] group-hover:text-[#000000B3]'
//                               }`}>
//                                 {chat.title}
//                               </h4>
//                             )}
//                             <p className="text-[13px] text-[#00000080] truncate">{chat.last_message}</p>
//                           </div>

//                           {(hoveredChatId === chat.chat_id || popoverOpenForId === chat.chat_id) && !renamingChatId && (
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setPopoverOpenForId(popoverOpenForId === chat.chat_id ? null : chat.chat_id);
//                               }}
//                               className="text-gray-500 hover:text-black p-1 rounded transition-colors flex-shrink-0"
//                             >
//                               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                                 <circle cx="5" cy="12" r="2" />
//                                 <circle cx="12" cy="12" r="2" />
//                                 <circle cx="19" cy="12" r="2" />
//                               </svg>
//                             </button>
//                           )}
//                         </div>

//                         {popoverOpenForId === chat.chat_id && (
//                           <div className="absolute right-8 top-8 bg-white border border-gray-100 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.1)] w-[160px] z-50 flex flex-col p-1.5 font-outfit">
//                             <button
//                               onClick={() => {
//                                 setRenameValue(chat.title);
//                                 setRenamingChatId(chat.chat_id);
//                                 setPopoverOpenForId(null);
//                               }}
//                               className="flex items-center gap-3 px-3 py-2.5 text-sm text-[#4B5563] hover:bg-gray-50 hover:text-black rounded-lg transition-colors text-left"
//                             >
//                               <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
//                                 <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
//                               </svg>
//                               Rename
//                             </button>
//                             <button
//                               onClick={() => {
//                                 setChatToDelete(chat.chat_id);
//                                 setPopoverOpenForId(null);
//                               }}
//                               className="flex items-center gap-3 px-3 py-2.5 text-sm text-[#E11D48] hover:bg-red-50 rounded-lg transition-colors text-left mt-0.5"
//                             >
//                               <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
//                                 <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                               </svg>
//                               Delete Chat
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         <div className="flex-1 flex flex-col min-w-0 relative">
//           {isLoadingChat ? (
//             <main className="flex-1 flex flex-col items-center justify-center">
//               <div className="flex gap-1.5 mb-4">
//                 <span className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "0ms" }}></span>
//                 <span className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "150ms" }}></span>
//                 <span className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "300ms" }}></span>
//               </div>
//               <p className="text-[#6B7280] text-sm font-medium">Loading chat session...</p>
//             </main>
//           ) : !hasMessages ? (
//             <main className="flex-1 flex items-center justify-center px-4 overflow-y-auto">
//               <div className="max-w-[80%] w-full text-center py-10">
//                 <p className="text-lg font-medium mb-2">
//                   <span className="text-[#3F3F46]">Hello, </span>
//                   <span className="text-[#BD4AB1]">{displayName ? displayName : "User"}!</span>
//                 </p>

//                 <h1 className="text-[20px] md:text-4xl font-semibold text-[#18101C] mb-6">
//                   What Can I Help You With Today
//                 </h1>
//                 <p className="text-sm md:text-base text-[#3F3F46] mb-10">
//                   Search, ask, and get insights from your Knowledge Base — all in one place.
//                 </p>

//                 <section>
//                   <div className="flex flex-wrap gap-4 justify-center">
//                     {suggestedPrompts.map((prompt, idx) => (
//                       <button
//                         key={idx}
//                         onClick={() => handlePromptClick(prompt)}
//                         className="flex flex-col justify-between text-left bg-white rounded-2xl shadow-sm border border-pink-100 px-4 py-3 min-h-[100px] w-[160px] hover:shadow-md transition-shadow"
//                       >
//                         <div className="flex items-start gap-3 mb-2">
//                           <span className="text-sm text-[#3F3F46] font-medium leading-tight flex-1">{prompt}</span>
//                         </div>
//                         <span className="inline-flex items-center justify-start text-pink-500 text-xs">{promptIcons[idx]}</span>
//                       </button>
//                     ))}
//                   </div>

//                   <div className="mt-8 flex justify-center">
//                     <button
//                       onClick={() => setIsPromptModalOpen(true)}
//                       className="bg-[#C95EBE] text-white px-4 py-[8px] rounded-full font-medium transition-colors shadow-sm"
//                     >
//                       Explore more Prompts
//                     </button>
//                   </div>
//                 </section>
//               </div>
//             </main>
//           ) : (
//             <main
//               ref={chatContainerRef}
//               onScroll={checkScrollPosition}
//               className="flex-1 overflow-y-auto px-4 py-4"
//             >
//               <div className="max-w-3xl mx-auto pb-4">
//                 {messages.map((message, index) => (
//                   <React.Fragment key={message.id}>
//                     {message.sender === "user" && (
//                       <div ref={index === messages.length - 1 || messages[index + 1]?.sender === "bot" ? lastUserMessageRef : null} />
//                     )}
//                     <div className={`mb-4 flex ${message.sender === "user" ? "justify-end" : "justify-start"}`}>
//                       {message.sender === "bot" && (
//                         <div className="flex-shrink-0 mr-2">
//                           <div className="w-8 h-8 rounded-full border border-[#0000001A] flex items-center justify-center">
//                             <BotAvatarIcon />
//                           </div>
//                         </div>
//                       )}

//                       <div
//                         className={`max-w-[80%] flex flex-col ${
//                           message.sender === "user"
//                             ? "bg-[#8B55DD29] text-[#3F3F46] rounded-2xl rounded-br-md px-4 py-2"
//                             : "bg-white rounded-2xl rounded-bl-md px-4 pt-3 pb-2 shadow-sm border border-pink-50"
//                         } ${message.isError ? "border-red-200 bg-red-50" : ""}`}
//                       >
//                         <div
//                           className="text-md text-[#3F3F46]"
//                           onClick={message.sender === "bot" ? handleMarkdownClick : undefined}
//                         >
//                           {renderMessageText(message.text)}
//                         </div>

//                         {message.sender === "bot" && !message.isError && (
//                           <div className="flex items-center gap-2 pt-3 mt-1 border-t border-gray-100">
//                             <button
//                               onClick={() => {
//                                 const alreadyUp = thumbsUpClicked[message.id];
//                                 setThumbsUpClicked((p) => ({
//                                   ...p,
//                                   [message.id]: !p[message.id],
//                                 }));
//                                 setThumbsDownClicked((p) => ({
//                                   ...p,
//                                   [message.id]: false,
//                                 }));
//                                 if (!alreadyUp) {
//                                   submitFeedback(message.id, "up");
//                                 }
//                               }}
//                             >
//                               <img
//                                 src={
//                                   thumbsUpClicked[message.id]
//                                     ? "/thums-up-filled.svg"
//                                     : "/thums-up.svg"
//                                 }
//                                 alt="Thumbs Up"
//                                 className="w-4 h-4"
//                               />
//                             </button>
//                             <button
//                               onClick={() => {
//                                 const alreadyDown = thumbsDownClicked[message.id];
//                                 setThumbsDownClicked((p) => ({
//                                   ...p,
//                                   [message.id]: !p[message.id],
//                                 }));
//                                 setThumbsUpClicked((p) => ({
//                                   ...p,
//                                   [message.id]: false,
//                                 }));
//                                 if (!alreadyDown) {
//                                   submitFeedback(message.id, "down");
//                                 }
//                               }}
//                             >
//                               <img
//                                 src={
//                                   thumbsDownClicked[message.id]
//                                     ? "/thums-down-filled.svg"
//                                     : "/thums-down.svg"
//                                 }
//                                 alt="Thumbs Down"
//                                 className="w-4 h-4"
//                               />
//                             </button>
//                             <button
//                               onClick={() =>
//                                 handleCopy(message.id, message.text)
//                               }
//                             >
//                               <img
//                                 src={
//                                   copiedMessageId === message.id
//                                     ? "/copy-clicked.svg"
//                                     : "/copy.svg"
//                                 }
//                                 alt="Copy"
//                                 className="w-4 h-4"
//                               />
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </React.Fragment>
//                 ))}

//                 {(isStreaming || loading) && (
//                   <div className="mb-4 flex justify-start">
//                     <div className="flex-shrink-0 mr-2">
//                       <div className="w-8 h-8 rounded-full border border-[#0000001A] flex items-center justify-center">
//                         <BotAvatarIcon />
//                       </div>
//                     </div>
//                     <div className="bg-white rounded-2xl rounded-bl-md px-4 py-2 shadow-sm border border-pink-50 max-w-[80%]">
//                       {streamingMessage ? (
//                         <div
//                           className="text-md text-[#3F3F46]"
//                           onClick={handleMarkdownClick}
//                         >
//                           <MemoizedMarkdown content={streamingMessage} />
//                         </div>
//                       ) : (
//                         <div className="flex items-center gap-2 py-1">
//                           <div className="flex gap-1">
//                             <span className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "0ms" }}></span>
//                             <span className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "150ms" }}></span>
//                             <span className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce" style={{ animationDelay: "300ms" }}></span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//                 <div ref={messagesEndRef} />
//               </div>
//             </main>
//           )}

//           {showScrollToBottom && (
//             <div className="absolute left-1/2 transform -translate-x-1/2 bottom-32 z-50">
//               <button
//                 onClick={scrollToBottom}
//                 className="bg-gradient-to-br from-[#C95EBE] to-[#BD4AB1] text-white rounded-full p-3 shadow-2xl hover:shadow-xl transition-all duration-200 hover:scale-110"
//               >
//                 <ScrollBottomIcon />
//               </button>
//             </div>
//           )}

//           <footer className="flex-shrink-0 bg-[#FEF9F7] pb-6 pt-3 px-6">
//             <div className="max-w-3xl mx-auto">
//               <div
//                 className="flex items-end gap-3 bg-white rounded-[28px] shadow-lg px-4 pt-3 pb-1"
//                 style={{ border: inputMessage.trim() ? "2px solid #E5C1DD" : "2px solid rgba(0, 0, 0, 0.1)" }}
//               >
//                 <textarea
//                   ref={textareaRef}
//                   value={inputMessage}
//                   onChange={handleTextInputChange}
//                   onKeyDown={handleKeyPress}
//                   placeholder={loading ? "Copilot is responding..." : "Ask me anything..."}
//                   disabled={loading}
//                   className="flex-1 border-0 focus:outline-none focus:ring-0 text-base text-[#3F3F46] placeholder-[#9CA3AF] bg-transparent font-outfit resize-none disabled:opacity-50"
//                   style={{ height: `${INITIAL_HEIGHT}px`, maxHeight: `${MAX_HEIGHT}px`, overflowY: "hidden" }}
//                 />
//                 <button
//                   onClick={handleSendMessage}
//                   disabled={loading || !inputMessage.trim()}
//                   className={`flex h-10 w-10 flex-shrink-0 items-center justify-center mb-1 rounded-full transition-all ${
//                     loading || !inputMessage.trim()
//                       ? "bg-[#D1D5DB] cursor-not-allowed"
//                       : "bg-gradient-to-br from-[#C95EBE] to-[#C95EBE] hover:shadow-lg"
//                   }`}
//                 >
//                   <SendIcon />
//                 </button>
//               </div>
//             </div>
//           </footer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default KBChat;

import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { emitPlanLimit } from "../../events/planLimitEvents";
import toast from "react-hot-toast";
import api from "../chat/api";
import {
  promptIcons,
  BotAvatarIcon,
  ScrollBottomIcon,
  SendIcon,
  NewICon,
} from "./ChatIcons";
import MemoizedMarkdown from "./Projects/MemoizedMarkdown";
import PromptLibraryModal from "./PromptLibraryModal";
import DeleteChatModal from "./DeleteChatModal";
import Tooltip from "./Projects/Project Page/Tooltip";
import SourceViewerModal from "./SourceViewerModal";
import FeedbackPopup from "./FeedbackPopup";

const INITIAL_HEIGHT = 40;
const MAX_HEIGHT = 200;

const WS_BASE_URL = process.env.REACT_APP_WS_URL || "ws://localhost:8000";

const groupChatsByDate = (chatSessions) => {
  if (!chatSessions || chatSessions.length === 0) return [];

  const groups = {
    Today: [],
    Yesterday: [],
    "Last 7 Days": [],
    Older: [],
  };

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  chatSessions.forEach((chat) => {
    const chatDate = new Date(chat.last_message_timestamp);
    const chatDay = new Date(chatDate);
    chatDay.setHours(0, 0, 0, 0);

    const diffTime = now - chatDay;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      groups["Today"].push(chat);
    } else if (diffDays === 1) {
      groups["Yesterday"].push(chat);
    } else if (diffDays > 1 && diffDays <= 7) {
      groups["Last 7 Days"].push(chat);
    } else {
      groups["Older"].push(chat);
    }
  });

  return Object.entries(groups)
    .filter(([_, chats]) => chats.length > 0)
    .map(([group, chats]) => ({ group, chats }));
};

const KBChat = ({ isMenuOpen }) => {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const navigate = useNavigate();

  const [displayName, setDisplayName] = useState("");
  const textareaRef = useRef(null);

  const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);

  const [activeSource, setActiveSource] = useState(null);

  const [hoveredChatId, setHoveredChatId] = useState(null);
  const [popoverOpenForId, setPopoverOpenForId] = useState(null);
  const [renamingChatId, setRenamingChatId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const renameInputRef = useRef(null);

  const [chatToDelete, setChatToDelete] = useState(null);

  const [chatHistory, setChatHistory] = useState([]);
  const [isChatHistoryLoading, setIsChatHistoryLoading] = useState(true);
  const [isLoadingChat, setIsLoadingChat] = useState(false);

  const chatContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const lastUserMessageRef = useRef(null);
  const shouldAutoScrollRef = useRef(false);

  const [chatId, setChatId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);

  const streamingMessageRef = useRef("");
  const [streamingMessage, setStreamingMessage] = useState("");

  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [lastStreamingHeight, setLastStreamingHeight] = useState(0);
  const [checkScrollInterval, setCheckScrollInterval] = useState(null);

  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const messageQueueRef = useRef([]);
  const pendingMetaRef = useRef(null);

  const [thumbsUpClicked, setThumbsUpClicked] = useState({});
  const [thumbsDownClicked, setThumbsDownClicked] = useState({});
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const [messageMetaMap, setMessageMetaMap] = useState({});

  const [activeFeedbackPopup, setActiveFeedbackPopup] = useState({
    isOpen: false,
    messageId: null,
    type: "down",
  });

  const hasMessages = messages.length > 0;

  const suggestedPrompts = [
    "Summarize the documents in my knowledge base",
    "What changed in the latest compliance update?",
    "Find invoices for pricing strategies in 2025",
    'Show me where "Proposal Evaluation Criteria" appears',
  ];

  const fetchChatHistory = async (showLoader = true) => {
    if (showLoader) setIsChatHistoryLoading(true);
    try {
      const response = await api.get(`/api/v1/rfp/kb-copilot/chats/`);
      if (response.data && response.data.chat_sessions) {
        const groupedChats = groupChatsByDate(response.data.chat_sessions);
        setChatHistory(groupedChats);
      }
    } catch (error) {
      console.error("Failed to fetch chat history:", error);
      if (showLoader) {
        toast.error("Failed to load chat history.", {
          position: "bottom-right",
          duration: 2000,
          style: {
            background: "#1a1a1a",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "14px",
          },
        });
      }
    } finally {
      if (showLoader) setIsChatHistoryLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverOpenForId && !e.target.closest(".chat-item-container")) {
        setPopoverOpenForId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [popoverOpenForId]);

  useEffect(() => {
    if (renamingChatId && renameInputRef.current) {
      renameInputRef.current.focus();
      renameInputRef.current.setSelectionRange(
        0,
        renameInputRef.current.value.length
      );
    }
  }, [renamingChatId]);

  const handleRenameSubmit = async (e) => {
    e.preventDefault();
    if (!renameValue.trim()) {
      setRenamingChatId(null);
      return;
    }

    try {
      await api.post(`/api/v1/copilot/rename-session/`, {
        chat_id: renamingChatId,
        new_title: renameValue.trim(),
      });
      setChatHistory((prevGroups) =>
        prevGroups.map((group) => ({
          ...group,
          chats: group.chats.map((chat) =>
            chat.chat_id === renamingChatId
              ? { ...chat, title: renameValue.trim() }
              : chat
          ),
        }))
      );
      toast.success("Chat renamed successfully", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
    } catch (error) {
      console.error("Failed to rename:", error);
      toast.error("Failed to rename chat", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
    } finally {
      setRenamingChatId(null);
    }
  };

  const onChatDeleted = (deletedId) => {
    setChatHistory((prevGroups) => {
      const newGroups = prevGroups
        .map((group) => ({
          ...group,
          chats: group.chats.filter((c) => c.chat_id !== deletedId),
        }))
        .filter((g) => g.chats.length > 0);
      return newGroups;
    });

    if (chatId === deletedId) {
      handleStartNewChat();
    }
  };

  const checkScrollPosition = () => {
    if (!chatContainerRef.current) return;
    const el = chatContainerRef.current;
    const scrollDiff = el.scrollHeight - el.scrollTop - el.clientHeight;
    setShowScrollToBottom(scrollDiff > 100);
    if (scrollDiff > 300) shouldAutoScrollRef.current = false;
  };

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
      shouldAutoScrollRef.current = true;
      setTimeout(() => setShowScrollToBottom(false), 300);
    }
  };

  const scrollToLastUserMessage = () => {
    if (lastUserMessageRef.current && chatContainerRef.current) {
      lastUserMessageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      shouldAutoScrollRef.current = false;
    }
  };

  useEffect(() => {
    if (!isStreaming || !shouldAutoScrollRef.current) return;
    const currentHeight = streamingMessage.length;
    const heightDiff = currentHeight - lastStreamingHeight;

    if (heightDiff > 5 && chatContainerRef.current) {
      const el = chatContainerRef.current;
      const scrollDiff = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (scrollDiff < 200) {
        requestAnimationFrame(() => {
          el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
        });
      }
    }
    setLastStreamingHeight(currentHeight);
  }, [streamingMessage, isStreaming]);

  useEffect(() => {
    if (isStreaming) {
      const interval = setInterval(checkScrollPosition, 500);
      setCheckScrollInterval(interval);
      return () => clearInterval(interval);
    } else if (checkScrollInterval) {
      clearInterval(checkScrollInterval);
      setCheckScrollInterval(null);
    }
  }, [isStreaming]);

  useEffect(() => {
    const full_name =
      localStorage.getItem("full_name") ||
      localStorage.getItem("fullName") ||
      "";
    const username = localStorage.getItem("username") || "";
    setDisplayName(full_name || username);

    const cookieToken = Cookies.get("access_token");
    if (cookieToken) {
      setToken(cookieToken);
    } else {
      navigate("/signin");
    }

    setChatId(null);
    setMessages([]);
    setMessageMetaMap({});
    fetchChatHistory(true);

    return () => {
      if (wsRef.current) wsRef.current.close(1000, "Leaving page");
    };
  }, [navigate]);

  const initiateNewChat = async () => {
    try {
      const response = await api.post(`api/v1/copilot/new-chat/`, {
        chat_module: "rfp_kb_copilot",
      });
      if (response.data.chat_id) {
        setChatId(response.data.chat_id);
        fetchChatHistory(false);
        return response.data.chat_id;
      } else if (
        response.data.msg === "You already have a recent chat session."
      ) {
        const activeChats = await api.get(`api/v1/copilot/chats/`);
        const latestChat = activeChats.data?.chat_sessions?.[0];
        if (latestChat?.id) {
          setChatId(latestChat.id);
          return latestChat.id;
        }
      }
      throw new Error("Chat ID not received");
    } catch (error) {
      toast.error("Failed to start a new chat. Please try again.", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
      return null;
    }
  };

  const handleWebSocketMessage = (data) => {
    const { type, status, message } = data;
    if (status === "connected") return;

    if (type === "info") {
      setIsStreaming(true);
      streamingMessageRef.current = "";
      setStreamingMessage("");
      setTimeout(scrollToLastUserMessage, 100);
      return;
    }

    if (type === "progress") {
      if (data.source === "true" || data.source === true) {
        const backendPage = data.page;

        if (
          !backendPage ||
          String(backendPage).trim() === "" ||
          isNaN(parseInt(backendPage, 10))
        ) {
          return;
        }

        const displayPageNum = parseInt(backendPage, 10);
        const safeFileName = (data.file_name || "").replace(/"/g, "&quot;");
        const safeFileUrl = (data.file_url || "").replace(/"/g, "&quot;");

        const rawContent = data.page_content || "";
        const singleLineContent = rawContent.replace(/[\r\n]+/g, " ");
        const safePageContent = singleLineContent.replace(/"/g, "&quot;");

        const inlineSourceHtml = ` <sup style="margin-left:2px;"><a href="#source_viewer" data-filename="${safeFileName}" data-fileurl="${safeFileUrl}" data-page="${displayPageNum}" data-pagecontent="${safePageContent}" style="font-size:12px; font-weight:600; color:#C95EBE; text-decoration:none; cursor:pointer;" title="View Source in ${safeFileName}, Page ${displayPageNum}">${displayPageNum}</a></sup>`;

        streamingMessageRef.current += inlineSourceHtml;
        setStreamingMessage(streamingMessageRef.current);
      } else {
        streamingMessageRef.current += message;
        setStreamingMessage(streamingMessageRef.current);
      }
      return;
    }

    if (type === "final") {
      pendingMetaRef.current = {
        run_id: data.data?.run_id || data.run_id || null,
        django_message_id:
          data.data?.bot_message_id || data.bot_message_id || null,
      };
      return;
    }

    if (type === "completed") {
      const finalText = streamingMessageRef.current;
      const meta = pendingMetaRef.current;
      const completedMsgId = meta?.django_message_id || Date.now();
      const completedRunId = meta?.run_id || null;

      if (finalText.trim()) {
        const botMessage = {
          id: completedMsgId,
          text: finalText,
          sender: "bot",
          timestamp: new Date().toISOString(),
        };
        setMessages((prev) => [...prev, botMessage]);

        if (completedRunId) {
          setMessageMetaMap((prev) => ({
            ...prev,
            [completedMsgId]: {
              run_id: completedRunId,
              django_message_id: completedMsgId,
            },
          }));
        }
      }
      pendingMetaRef.current = null;
      streamingMessageRef.current = "";
      setStreamingMessage("");
      setIsStreaming(false);
      setLoading(false);
      setLastStreamingHeight(0);
      setTimeout(checkScrollPosition, 100);
      fetchChatHistory(false);
      return;
    }

    if (type === "error" || data.error) {
      if (data.code === "plan_limit") emitPlanLimit(data.message || data.error);
      const errorMessage = {
        id: Date.now(),
        text: data.error || message || "An error occurred. Please try again.",
        sender: "bot",
        timestamp: new Date().toISOString(),
        isError: true,
      };
      setMessages((prev) => [...prev, errorMessage]);
      pendingMetaRef.current = null;
      streamingMessageRef.current = "";
      setStreamingMessage("");
      setIsStreaming(false);
      setLoading(false);
      return;
    }
  };

  const connectWebSocket = (chatIdToUse) => {
    if (!chatIdToUse || !token) return;
    if (wsRef.current) wsRef.current.close();
    const wsUrl = `${WS_BASE_URL}/ws/rfp-kb-copilot-chat/${chatIdToUse}/?token=${token}`;
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      setIsConnected(true);
      while (messageQueueRef.current.length > 0) {
        ws.send(JSON.stringify(messageQueueRef.current.shift()));
      }
    };
    ws.onmessage = (event) => {
      try {
        handleWebSocketMessage(JSON.parse(event.data));
      } catch (error) {}
    };
    ws.onerror = () => setIsConnected(false);
    ws.onclose = (event) => {
      setIsConnected(false);
      if (event.code !== 1000) {
        reconnectTimeoutRef.current = setTimeout(() => {
          if (chatId) connectWebSocket(chatId);
        }, 3000);
      }
    };
  };

  const sendWebSocketMessage = (messageText) => {
    const payload = { client_message: messageText, organization_id: Cookies.get("selected_org_id") || undefined };
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(payload));
    } else {
      messageQueueRef.current.push(payload);
      if (chatId) connectWebSocket(chatId);
    }
  };

  const resizeTextarea = (ta) => {
    if (!ta) return;
    ta.style.height = `${INITIAL_HEIGHT}px`;
    if (ta.value.trim() || ta.value.length > 0) {
      const full = ta.scrollHeight;
      const next =
        full <= INITIAL_HEIGHT ? INITIAL_HEIGHT : Math.min(full, MAX_HEIGHT);
      ta.style.height = `${next}px`;
      ta.style.overflowY = full > MAX_HEIGHT ? "auto" : "hidden";
    } else {
      ta.style.height = `${INITIAL_HEIGHT}px`;
      ta.style.overflowY = "hidden";
    }
  };

  const handleTextInputChange = (e) => {
    setInputMessage(e.target.value);
    if (e.target.value.trim() || e.target.value.length > 0) {
      resizeTextarea(e.target);
    } else {
      e.target.style.height = `${INITIAL_HEIGHT}px`;
      e.target.style.overflowY = "hidden";
    }
  };

  useLayoutEffect(() => {
    if (inputMessage === "" && textareaRef.current) {
      textareaRef.current.style.height = `${INITIAL_HEIGHT}px`;
      textareaRef.current.style.overflowY = "hidden";
    }
  }, [inputMessage]);

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || loading) return;

    setActiveFeedbackPopup({ isOpen: false, messageId: null, type: "down" });

    const userMessageText = inputMessage.trim();
    const userMessage = {
      id: Date.now(),
      text: userMessageText,
      sender: "user",
      timestamp: new Date().toISOString(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputMessage("");

    if (textareaRef.current) {
      textareaRef.current.style.height = `${INITIAL_HEIGHT}px`;
      textareaRef.current.style.overflowY = "hidden";
    }

    setLoading(true);
    shouldAutoScrollRef.current = false;
    streamingMessageRef.current = "";
    setStreamingMessage("");

    try {
      let currentChatId = chatId;
      if (!currentChatId) {
        currentChatId = await initiateNewChat();
        if (!currentChatId) throw new Error("Failed to create chat session");
      }

      if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
        connectWebSocket(currentChatId);
        messageQueueRef.current.push({ client_message: userMessageText, organization_id: Cookies.get("selected_org_id") || undefined });
      } else {
        sendWebSocketMessage(userMessageText);
      }
    } catch (error) {
      toast.error("Failed to send message. Please try again.", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          text: "An error occurred. Please try again.",
          sender: "bot",
          isError: true,
        },
      ]);
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handlePromptClick = (prompt) => {
    setInputMessage(prompt);
    if (textareaRef.current) {
      textareaRef.current.focus();
      setTimeout(() => resizeTextarea(textareaRef.current), 0);
    }
  };

  const handleStartNewChat = () => {
    setActiveFeedbackPopup({ isOpen: false, messageId: null, type: "down" });
    setChatId(null);
    setMessages([]);
    setMessageMetaMap({});
    setInputMessage("");
    setLoading(false);
    setIsStreaming(false);
    setStreamingMessage("");
    streamingMessageRef.current = "";
    pendingMetaRef.current = null;
    if (wsRef.current) {
      wsRef.current.close(1000, "Starting new chat");
      wsRef.current = null;
    }
  };

  const handleLoadPastChat = async (pastChatId) => {
    if (
      chatId === pastChatId ||
      popoverOpenForId === pastChatId ||
      renamingChatId === pastChatId
    )
      return;

    setActiveFeedbackPopup({ isOpen: false, messageId: null, type: "down" });
    setChatId(pastChatId);
    setIsLoadingChat(true);
    setLoading(false);
    setIsStreaming(false);
    setStreamingMessage("");
    streamingMessageRef.current = "";
    pendingMetaRef.current = null;
    setInputMessage("");

    if (wsRef.current) {
      wsRef.current.close(1000, "Switching chats");
      wsRef.current = null;
    }

    try {
      const response = await api.get(
        `/api/v1/copilot/get-chat-sessions/${pastChatId}/`
      );
      let chatData = [];
      if (response.data && Array.isArray(response.data.chat_history)) {
        chatData = response.data.chat_history;
      }

      const metaMap = {};
      const formattedMessages = chatData.map((msg) => {
        const messageId = msg.django_message_id || Date.now() + Math.random();

        if (!msg.is_client && msg.run_id) {
          metaMap[messageId] = {
            run_id: msg.run_id,
            django_message_id:
              msg.django_message_id || msg.bot_message_id || null,
          };
        }

        return {
          id: messageId,
          text: msg.message || "",
          sender: msg.is_client ? "user" : "bot",
          timestamp: msg.timestamp || new Date().toISOString(),
          isError: false,
        };
      });

      setMessages(formattedMessages);
      setMessageMetaMap(metaMap);
      connectWebSocket(pastChatId);
    } catch (error) {
      toast.error("Failed to load this chat. Please try again later.", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
      setMessages([]);
      setMessageMetaMap({});
    } finally {
      setIsLoadingChat(false);
      setTimeout(scrollToBottom, 100);
    }
  };

  const handleCopy = (messageId, text) => {
    const textWithoutHtml = text.replace(
      /<sup\b[^>]*><a\b[^>]*>(.*?)<\/a><\/sup>/gi,
      " [$1] "
    );
    navigator.clipboard.writeText(textWithoutHtml).then(() => {
      setCopiedMessageId(messageId);
      setTimeout(() => setCopiedMessageId(null), 2000);
    });
  };

  const handleMarkdownClick = (e) => {
    const anchor = e.target.closest("a");
    if (anchor && anchor.getAttribute("href") === "#source_viewer") {
      e.preventDefault();

      const fileName = anchor.getAttribute("data-filename");
      const fileUrl = anchor.getAttribute("data-fileurl");
      const page = anchor.getAttribute("data-page");
      const pageContent = anchor.getAttribute("data-pagecontent");

      if (!fileUrl && !fileName) return;

      setActiveSource({
        file_name: fileName,
        file_url: fileUrl,
        page: page,
        page_content: pageContent,
      });
    }
  };

  const renderMessageText = (text) => <MemoizedMarkdown content={text} />;

  const filteredChatHistory = chatHistory
    .map((group) => ({
      ...group,
      chats: group.chats.filter((chat) =>
        chat.title.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    }))
    .filter((group) => group.chats.length > 0);

  return (
    <div className="h-screen flex flex-col bg-[#FEF9F7] font-outfit overflow-hidden">
      <SourceViewerModal
        source={activeSource}
        onClose={() => setActiveSource(null)}
      />

      {isPromptModalOpen && (
        <PromptLibraryModal
          onClose={() => setIsPromptModalOpen(false)}
          onSelectPrompt={(promptText) => {
            setIsPromptModalOpen(false);
            handlePromptClick(promptText);
          }}
        />
      )}

      <DeleteChatModal
        isOpen={!!chatToDelete}
        onClose={() => setChatToDelete(null)}
        chatId={chatToDelete}
        onDeleted={onChatDeleted}
      />

      <header className="flex-shrink-0 pt-4 px-2 pb-4 bg-white border-b-2 border-[#0000001A] w-full z-20">
        <button
          onClick={() => navigate("/rfp-knowledgeBase")}
          className="inline-flex items-center gap-3 text-black hover:text-gray-700 transition-colors"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          <span className="font-semibold text-[18px]">
            Go to Knowledge Base
          </span>
        </button>
      </header>

      <div className="flex-1 flex overflow-hidden">
        <div className="w-[300px] md:w-[320px] bg-white border-r border-gray-200 flex flex-col flex-shrink-0 z-10">
          <div className="px-5 py-4 flex-shrink-0">
            <h2 className="text-[13px] text-[#4B5563] font-medium mb-3">
              YOUR CHATS
            </h2>
            <div className="flex gap-3 items-center mb-4">
              <div className="flex-1 flex items-center bg-[#F3F4F6] rounded-[6px] px-3 py-2">
                <svg
                  className="w-[18px] h-[18px] text-[#6B7280] flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-4.35-4.35m1.85-5.15a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Search a chat..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full bg-transparent border-none outline-none text-[14px] ml-2 text-[#3F3F46] placeholder-[#9CA3AF] focus:outline-none"
                  style={{ fontSize: "14px", lineHeight: "20px" }}
                />
              </div>

              <Tooltip content="Start New Chat" placement="right">
                <button
                  onClick={handleStartNewChat}
                  className="text-[#6B7280] hover:text-black transition-colors flex-shrink-0"
                >
                  <NewICon />
                </button>
              </Tooltip>
            </div>
            <div className="border-b border-gray-100 mt-2"></div>
          </div>

          <div className="flex-1 overflow-y-auto px-5 pb-4 custom-scrollbar relative">
            {isChatHistoryLoading ? (
              <div className="flex items-center justify-center py-6 text-[13px] text-[#6B7280]">
                Loading your chats...
              </div>
            ) : chatHistory.length === 0 ? (
              <div className="flex items-center justify-center py-6 text-[13px] text-[#6B7280]">
                No chat history found.
              </div>
            ) : filteredChatHistory.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                <span className="text-[28px] mb-2">🔍</span>
                <p className="text-[14px] text-[#4B5563] font-medium">
                  No results found for "{searchQuery}"
                </p>
                <p className="text-[12px] text-[#9CA3AF] mt-1">
                  Try another keyword or start a new chat.
                </p>
              </div>
            ) : (
              filteredChatHistory.map((group, index) => (
                <div key={index} className="mb-3">
                  <h3 className="text-[#BD4AB1] text-[15px] font-medium mb-2">
                    {group.group}
                  </h3>
                  <div className="flex flex-col gap-1">
                    {group.chats.map((chat) => (
                      <div
                        key={chat.chat_id}
                        className="chat-item-container relative"
                        onMouseEnter={() => setHoveredChatId(chat.chat_id)}
                        onMouseLeave={() => setHoveredChatId(null)}
                      >
                        <div
                          onClick={() => handleLoadPastChat(chat.chat_id)}
                          className={`cursor-pointer group px-2 py-1 rounded-md transition-colors flex justify-between items-start ${
                            chatId === chat.chat_id ||
                            popoverOpenForId === chat.chat_id
                              ? "bg-[#F3F4F6] -mx-2 px-4"
                              : "-mx-2 px-4 hover:bg-gray-50"
                          }`}
                        >
                          <div className="flex-1 min-w-0 pr-4">
                            {renamingChatId === chat.chat_id ? (
                              <form onSubmit={handleRenameSubmit}>
                                <input
                                  ref={renameInputRef}
                                  type="text"
                                  value={renameValue}
                                  onChange={(e) => setRenameValue(e.target.value)}
                                  onBlur={handleRenameSubmit}
                                  className="w-full h-8 text-[14px] leading-snug rounded-[4px] border-2 border-[#E5C1DD] outline-none bg-white text-[#000000B3] placeholder-gray-400 focus:outline-none shadow-sm transition-[border-color,box-shadow]"
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                  }}
                                />
                              </form>
                            ) : (
                              <h4
                                className={`text-[14px] font-medium leading-snug mb-0.5 truncate ${
                                  chatId === chat.chat_id ||
                                  popoverOpenForId === chat.chat_id
                                    ? "text-[#000000B3]"
                                    : "text-[#000000B3] group-hover:text-[#000000B3]"
                                }`}
                              >
                                {chat.title}
                              </h4>
                            )}
                            <p className="text-[13px] text-[#00000080] truncate">
                              {chat.last_message}
                            </p>
                          </div>

                          {(hoveredChatId === chat.chat_id ||
                            popoverOpenForId === chat.chat_id) &&
                            !renamingChatId && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPopoverOpenForId(
                                    popoverOpenForId === chat.chat_id
                                      ? null
                                      : chat.chat_id
                                  );
                                }}
                                className="text-gray-500 hover:text-black p-1 rounded transition-colors flex-shrink-0"
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <circle cx="5" cy="12" r="2" />
                                  <circle cx="12" cy="12" r="2" />
                                  <circle cx="19" cy="12" r="2" />
                                </svg>
                              </button>
                            )}
                        </div>

                        {popoverOpenForId === chat.chat_id && (
                          <div className="absolute right-8 top-8 bg-white border border-gray-100 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.1)] w-[160px] z-50 flex flex-col p-1.5 font-outfit">
                            <button
                              onClick={() => {
                                setRenameValue(chat.title);
                                setRenamingChatId(chat.chat_id);
                                setPopoverOpenForId(null);
                              }}
                              className="flex items-center gap-3 px-3 py-2.5 text-sm text-[#4B5563] hover:bg-gray-50 hover:text-black rounded-lg transition-colors text-left"
                            >
                              <svg
                                width="15"
                                height="15"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                />
                              </svg>
                              Rename
                            </button>
                            <button
                              onClick={() => {
                                setChatToDelete(chat.chat_id);
                                setPopoverOpenForId(null);
                              }}
                              className="flex items-center gap-3 px-3 py-2.5 text-sm text-[#E11D48] hover:bg-red-50 rounded-lg transition-colors text-left mt-0.5"
                            >
                              <svg
                                width="15"
                                height="15"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                              Delete Chat
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="flex-1 flex flex-col min-w-0 relative">
          {isLoadingChat ? (
            <main className="flex-1 flex flex-col items-center justify-center">
              <div className="flex gap-1.5 mb-4">
                <span
                  className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce"
                  style={{ animationDelay: "0ms" }}
                ></span>
                <span
                  className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce"
                  style={{ animationDelay: "150ms" }}
                ></span>
                <span
                  className="w-2.5 h-2.5 bg-[#C95EBE] rounded-full animate-bounce"
                  style={{ animationDelay: "300ms" }}
                ></span>
              </div>
              <p className="text-[#6B7280] text-sm font-medium">
                Loading chat session...
              </p>
            </main>
          ) : !hasMessages ? (
            <main className="flex-1 flex items-center justify-center px-4 overflow-y-auto">
              <div className="max-w-[80%] w-full text-center py-10">
                <p className="text-lg font-medium mb-2">
                  <span className="text-[#3F3F46]">Hello, </span>
                  <span className="text-[#BD4AB1]">
                    {displayName ? displayName : "User"}!
                  </span>
                </p>

                <h1 className="text-[20px] md:text-4xl font-semibold text-[#18101C] mb-6">
                  What Can I Help You With Today
                </h1>
                <p className="text-sm md:text-base text-[#3F3F46] mb-10">
                  Search, ask, and get insights from your Knowledge Base — all
                  in one place.
                </p>

                <section>
                  <div className="flex flex-wrap gap-4 justify-center">
                    {suggestedPrompts.map((prompt, idx) => (
                      <button
                        key={idx}
                        onClick={() => handlePromptClick(prompt)}
                        className="flex flex-col justify-between text-left bg-white rounded-2xl shadow-sm border border-pink-100 px-4 py-3 min-h-[100px] w-[160px] hover:shadow-md transition-shadow"
                      >
                        <div className="flex items-start gap-3 mb-2">
                          <span className="text-sm text-[#3F3F46] font-medium leading-tight flex-1">
                            {prompt}
                          </span>
                        </div>
                        <span className="inline-flex items-center justify-start text-pink-500 text-xs">
                          {promptIcons[idx]}
                        </span>
                      </button>
                    ))}
                  </div>

                  <div className="mt-8 flex justify-center">
                    <button
                      onClick={() => setIsPromptModalOpen(true)}
                      className="bg-[#C95EBE] text-white px-4 py-[8px] rounded-full font-medium transition-colors shadow-sm"
                    >
                      Explore more Prompts
                    </button>
                  </div>
                </section>
              </div>
            </main>
          ) : (
            <main
              ref={chatContainerRef}
              onScroll={checkScrollPosition}
              className="flex-1 overflow-y-auto px-4 py-4"
            >
              <div className="max-w-3xl mx-auto pb-4">
                {messages.map((message, index) => (
                  <React.Fragment key={message.id}>
                    {message.sender === "user" && (
                      <div
                        ref={
                          index === messages.length - 1 ||
                          messages[index + 1]?.sender === "bot"
                            ? lastUserMessageRef
                            : null
                        }
                      />
                    )}
                    <div
                      className={`mb-4 flex ${
                        message.sender === "user"
                          ? "justify-end"
                          : "justify-start"
                      }`}
                    >
                      {message.sender === "bot" && (
                        <div className="flex-shrink-0 mr-2">
                          <div className="w-8 h-8 rounded-full border border-[#0000001A] flex items-center justify-center">
                            <BotAvatarIcon />
                          </div>
                        </div>
                      )}

                      <div
                        className={`max-w-[80%] flex flex-col ${
                          message.sender === "user"
                            ? "bg-[#8B55DD29] text-[#3F3F46] rounded-2xl rounded-br-md px-4 py-2"
                            : "bg-white rounded-2xl rounded-bl-md px-4 pt-3 pb-2 shadow-sm border border-pink-50"
                        } ${message.isError ? "border-red-200 bg-red-50" : ""}`}
                      >
                        <div
                          className="text-md text-[#3F3F46]"
                          onClick={
                            message.sender === "bot"
                              ? handleMarkdownClick
                              : undefined
                          }
                        >
                          {renderMessageText(message.text)}
                        </div>

                        {message.sender === "bot" && !message.isError && (
                          <div
                            id={`feedback-btns-${message.id}`}
                            className="flex items-center gap-2 pt-3 mt-1 border-t border-gray-100 relative"
                          >
                            <button
                              onClick={() => {
                                const alreadyUp = thumbsUpClicked[message.id];
                                setThumbsUpClicked((p) => ({
                                  ...p,
                                  [message.id]: !p[message.id],
                                }));
                                setThumbsDownClicked((p) => ({
                                  ...p,
                                  [message.id]: false,
                                }));
                                if (!alreadyUp) {
                                  setActiveFeedbackPopup({
                                    isOpen: true,
                                    messageId: message.id,
                                    type: "up",
                                  });
                                }
                              }}
                            >
                              <img
                                src={
                                  thumbsUpClicked[message.id]
                                    ? "/thums-up-filled.svg"
                                    : "/thums-up.svg"
                                }
                                alt="Thumbs Up"
                                className="w-4 h-4"
                              />
                            </button>
                            <button
                              onClick={() => {
                                const alreadyDown =
                                  thumbsDownClicked[message.id];
                                setThumbsDownClicked((p) => ({
                                  ...p,
                                  [message.id]: !p[message.id],
                                }));
                                setThumbsUpClicked((p) => ({
                                  ...p,
                                  [message.id]: false,
                                }));
                                if (!alreadyDown) {
                                  setActiveFeedbackPopup({
                                    isOpen: true,
                                    messageId: message.id,
                                    type: "down",
                                  });
                                }
                              }}
                            >
                              <img
                                src={
                                  thumbsDownClicked[message.id]
                                    ? "/thums-down-filled.svg"
                                    : "/thums-down.svg"
                                }
                                alt="Thumbs Down"
                                className="w-4 h-4"
                              />
                            </button>
                            <button
                              onClick={() => handleCopy(message.id, message.text)}
                            >
                              <img
                                src={
                                  copiedMessageId === message.id
                                    ? "/copy-clicked.svg"
                                    : "/copy.svg"
                                }
                                alt="Copy"
                                className="w-4 h-4"
                              />
                            </button>

                            <FeedbackPopup
                              isOpen={
                                activeFeedbackPopup.isOpen &&
                                activeFeedbackPopup.messageId === message.id
                              }
                              onClose={() =>
                                setActiveFeedbackPopup({
                                  isOpen: false,
                                  messageId: null,
                                  type: "down",
                                })
                              }
                              messageId={message.id}
                              feedbackType={activeFeedbackPopup.type}
                              messageMeta={messageMetaMap[message.id]}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ))}

                {(isStreaming || loading) && (
                  <div className="mb-4 flex justify-start">
                    <div className="flex-shrink-0 mr-2">
                      <div className="w-8 h-8 rounded-full border border-[#0000001A] flex items-center justify-center">
                        <BotAvatarIcon />
                      </div>
                    </div>
                    <div className="bg-white rounded-2xl rounded-bl-md px-4 py-2 shadow-sm border border-pink-50 max-w-[80%]">
                      {streamingMessage ? (
                        <div
                          className="text-md text-[#3F3F46]"
                          onClick={handleMarkdownClick}
                        >
                          <MemoizedMarkdown content={streamingMessage} />
                        </div>
                      ) : (
                        <div className="flex items-center gap-2 py-1">
                          <div className="flex gap-1">
                            <span
                              className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce"
                              style={{ animationDelay: "0ms" }}
                            ></span>
                            <span
                              className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce"
                              style={{ animationDelay: "150ms" }}
                            ></span>
                            <span
                              className="w-2 h-2 bg-[#C95EBE] rounded-full animate-bounce"
                              style={{ animationDelay: "300ms" }}
                            ></span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>
            </main>
          )}

          {showScrollToBottom && (
            <div className="absolute left-1/2 transform -translate-x-1/2 bottom-32 z-50">
              <button
                onClick={scrollToBottom}
                className="bg-gradient-to-br from-[#C95EBE] to-[#BD4AB1] text-white rounded-full p-3 shadow-2xl hover:shadow-xl transition-all duration-200 hover:scale-110"
              >
                <ScrollBottomIcon />
              </button>
            </div>
          )}

          <footer className="flex-shrink-0 bg-[#FEF9F7] pb-6 pt-3 px-6">
            <div className="max-w-3xl mx-auto">
              <div
                className="flex items-end gap-3 bg-white rounded-[28px] shadow-lg px-4 pt-3 pb-1"
                style={{
                  border: inputMessage.trim()
                    ? "2px solid #E5C1DD"
                    : "2px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <textarea
                  ref={textareaRef}
                  value={inputMessage}
                  onChange={handleTextInputChange}
                  onKeyDown={handleKeyPress}
                  placeholder={
                    loading ? "Copilot is responding..." : "Ask me anything..."
                  }
                  disabled={loading}
                  className="flex-1 border-0 focus:outline-none focus:ring-0 text-base text-[#3F3F46] placeholder-[#9CA3AF] bg-transparent font-outfit resize-none disabled:opacity-50"
                  style={{
                    height: `${INITIAL_HEIGHT}px`,
                    maxHeight: `${MAX_HEIGHT}px`,
                    overflowY: "hidden",
                  }}
                />
                <button
                  onClick={handleSendMessage}
                  disabled={loading || !inputMessage.trim()}
                  className={`flex h-10 w-10 flex-shrink-0 items-center justify-center mb-1 rounded-full transition-all ${
                    loading || !inputMessage.trim()
                      ? "bg-[#D1D5DB] cursor-not-allowed"
                      : "bg-gradient-to-br from-[#C95EBE] to-[#C95EBE] hover:shadow-lg"
                  }`}
                >
                  <SendIcon />
                </button>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default KBChat;